const HomeAbout = () => (
   <div className='container section-container'>
      <h2 className='title'>О компании</h2>
      <div className='article'>
         <b>
            Добро пожаловать на сайт Компании Reginox Reef Holding(ООО «РеджиноксРиф Холдинг») — единственного и
            официального представителя производителя сантехнической продукции для кухни и ванной комнаты Reginox
            (Нидерланды).
         </b>
         <p>
            Основной специализацией нашей компании являются розничные и оптовые продажи кухонной сантехники по всей
            России. Мы предлагаемкухонные мойки из нержавеющей стали и гранитного композита, смесители для кухни, а
            также оригинальную продукцию от Reginox:
         </p>
         <ul>
            <li>умывальники</li>
            <li>окрашенные мойки</li>
            <li>системы газовых конфорок PITTbyReginox</li>
            <li>многофункциональные кухонные комплексы и др.</li>
         </ul>
         <p>
            Более 25 лет назад компания RRHolding представила на российском
            рынке кухонные мойки Reginox из нержавеющей стали, приятно удивившие
            покупателей отличным качеством, многообразием моделейи современным
            дизайном. Продукция Reginox входит в постоянный ассортимент ряда
            крупных фабрик-производителей мебели, введена в предложение
            крупнейших продавцов мебельной фурнитуры и комплектующих, и
            представлена вомножестве кухонных салонов по всей России. За годы
            нашей работы мы заключили контракты в сферах:
         </p>
         <ul>
            <li>авиастроение</li>
            <li>вагоностроение</li>
            <li>судостроение</li>
            <li>здравоохранение</li>
            <li>предприятия общественного питания</li>
            <li>иные учреждения сферы обслуживания и др.</li>
         </ul>
         <h3 className='title-1'>наши преимущества</h3>
         <ul>
            <li>
               многолетний опыт, профессиональный подход, надежное партнерствои
               отличная репутация на рынке
            </li>
            <li>
               высококачественный европейский товар и гарантия производителя,
               соответствие всем международным и российским стандартами
               требованиям
            </li>
            <li>
               постоянное наличие на складе Москвы и
               Санкт-Петербурга(официальное представительство ООО «Ревестал»), а
               также возможность изготовления под индивидуальный заказ
            </li>
            <li>
               работа с розничными покупателями, с мелкооптовыми и
               крупнооптовыми заказчиками, сотрудничество с каждым покупателем
               или бизнес-партнеромпо специальной программе и индивидуальной
               ценовой политике
            </li>
            <li>
               широкий ассортимент и различные модификации, позволяющие
               реализоватьпроекты в различных сферах- доставка в любую точку
               России
            </li>
         </ul>
         <p>
            Благодаря многолетнему и плодотворному тандему RRHolding и Reginox,
            сегодня мы имеем большое количество бизнес-партнеров, в том числе и
            за пределами РФ, с которыми поддерживаем и развиваем взаимовыгодные
            отношения, приобрели популярность среди потребителей, и сохранили за
            собой статус компании, предлагающей на рынке России продукцию со
            «стальной репутацией». Мы предлагаем лучшее качество от европейского
            завода-производителя (завод расположен в Нидерландах, город Rijssen)
            и пожизненную гарантию на продукцию из нержавеющей стали!
         </p>
      </div>
   </div>
)

export default HomeAbout
